export const doubleChevronRightIcon = {
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M17.866 10L7.898 0 6.855 1.04l8.93 8.96-8.93 8.96L7.898 20zm-4.852 0L3.047 0 2.004 1.04l8.93 8.96-8.93 8.96L3.047 20z"/></svg>`,
  name: 'double-chevron-right',
};
